// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Mgb3","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1lp0L"};